import { CbhFeatureFlag } from "../FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../FeatureFlags/useCbhFlag";

export function useLicenseNumberRequirementsFlag() {
  return useCbhFlag(CbhFeatureFlag.HCP_LICENSE_NUMBER_REQUIREMENTS, {
    defaultValue: {},
  });
}
